import firebase from 'firebase/compat/app';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBo9CUsKlEGUkYTsjdTy5n6Q3X9i7ec-RQ",
    authDomain: "bcs-public-portal.firebaseapp.com",
    projectId: "bcs-public-portal",
    storageBucket: "bcs-public-portal.appspot.com",
    messagingSenderId: "823547668549",
    appId: "1:823547668549:web:4f556bc096f5d480e49b2c"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }


//export all the details we need!
export const appp = initializeApp(firebaseConfig);
export const storage = getStorage(app)
export const auth = getAuth(app);
export const db = getFirestore(app)
export default firebase;




